module.exports = __webpack_public_path__ + "img/iconBack.51c68f03.svg";